import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      id="footer"
      data-testid="site-footer"
      className="relative bg-ink text-paper pt-14 pb-12"
    >
      <div className="max-w-[1080px] mx-auto px-6 md:px-10 lg:px-14">
        {/* Row 1 — logo LEFT + phone RIGHT, aligned on the same baseline */}
        <div
          data-testid="footer-brand-row"
          className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-4 pb-10 border-b border-paper/15"
        >
          <a
            href="https://josfamilylaw.com"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-logo-link"
            className="inline-flex items-center select-none"
          >
            <img
              src="/brand/jos-logo.png"
              alt="Jos Family Law — visit josfamilylaw.com"
              className="h-10 md:h-12 w-auto brightness-0 invert opacity-95 hover:opacity-100 transition-opacity"
              draggable={false}
            />
          </a>

          <a
            href="tel:+17147337066"
            data-testid="footer-phone"
            className="inline-flex items-center gap-3 font-display text-[26px] md:text-[32px] tracking-tight text-paper hover:text-teal transition-colors"
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            (714) 733-7066
          </a>
        </div>

        {/* Row 2 — attorney details block */}
        <div className="pt-10 grid grid-cols-1 md:grid-cols-[1fr_1fr] gap-8 md:gap-14">
          <div>
            <p className="font-display italic text-2xl md:text-[26px] text-paper leading-tight">
              Binoye Jos, Esq.
            </p>
            <p className="mt-2 font-body text-[14px] leading-[1.9] text-paper/85">
              Jos Family Law
            </p>
            <address className="mt-2 not-italic font-body text-[14px] leading-[1.9] text-paper/85">
              1918 W. Chapman Avenue, Suite 200
              <br />
              Orange, CA 92868
            </address>
          </div>

          <div className="md:pt-1">
            <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-paper/50 mb-2">
              Responsible Attorney
            </p>
            <p className="font-body text-[14px] leading-[1.7] text-paper/85">
              Binoye Jos, Member, State Bar of California
            </p>
          </div>
        </div>

        {/* Row 3 — legal disclaimer paragraph */}
        <p
          data-testid="footer-legal-disclaimer"
          className="mt-10 font-body text-[12px] leading-[1.85] text-paper/65 max-w-[80ch]"
        >
          <span
            data-testid="footer-prior-results-disclaimer"
            className="italic"
          >
            Prior results do not guarantee a similar outcome.
          </span>{" "}
          This communication is attorney advertising. Information provided is
          for general informational purposes only and does not constitute
          legal advice. Contacting Jos Family Law does not create an
          attorney-client relationship.
        </p>

        {/* Divider */}
        <div className="my-10 h-px bg-paper/15" aria-hidden />

        {/* Row 4 — legal links + copyright */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
          <div className="flex items-center gap-5 text-[13px] font-body text-paper/85">
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-link"
              className="hover:text-teal transition-colors"
            >
              Privacy Policy
            </Link>
            <span aria-hidden className="text-paper/30">
              |
            </span>
            <Link
              to="/terms-of-use"
              data-testid="footer-terms-link"
              className="hover:text-teal transition-colors"
            >
              Terms of Use
            </Link>
          </div>

          <p className="text-[12px] leading-relaxed text-paper/55">
            &copy; {new Date().getFullYear()} Jos Family Law. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
